import { Mappable } from './mappable';

export class Country extends Mappable {
  code: string;
  name: string;
  vat: string;

  constructor() { super() }
}
